(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-halloween"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ikier-halloween-tabs')) {
    customElements.define('ikier-halloween-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tablist = this.querySelector('[role="tablist"]');
        if (!this.tabs.length) return;

        this.mobile = window.matchMedia('(max-width: 767px)');
        const setOrientation = () => {
          this.tablist.setAttribute('aria-orientation', this.hasAttribute('data-horizontal') || this.mobile.matches ? 'horizontal' : 'vertical');
        };
        setOrientation();
        this.mobile.addEventListener('change', setOrientation, options);

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.activate(index);
        }, options);

        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          const horizontal = this.tablist.getAttribute('aria-orientation') === 'horizontal';
          const previousKey = horizontal ? 'ArrowLeft' : 'ArrowUp';
          const nextKey = horizontal ? 'ArrowRight' : 'ArrowDown';
          let nextIndex;
          if (event.key === previousKey) nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === nextKey) nextIndex = (index + 1) % this.tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(nextIndex);
          this.tabs[nextIndex].focus();
        }, options);


        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-product-variant]');
          if (!select) return;
          const card = select.closest('[data-product-card]');
          const option = select.selectedOptions[0];
          if (!card || !option) return;
          const data = option.dataset;
          card.querySelector('[data-current-price]').textContent = data.price;
          const compare = card.querySelector('[data-compare-price]');
          compare.textContent = data.compare;
          compare.hidden = !data.compare;
          const saving = card.querySelector('[data-saving-label]');
          saving.textContent = data.saving;
          saving.hidden = !data.saving;
          const available = data.available === 'true';
          const buy = card.querySelector('[data-buy-now]');
          buy.textContent = available ? this.dataset.buyLabel : this.dataset.soldOutLabel;
          if (available) {
            buy.href = data.checkout;
            buy.removeAttribute('aria-disabled');
            buy.removeAttribute('tabindex');
          } else {
            buy.removeAttribute('href');
            buy.setAttribute('aria-disabled', 'true');
            buy.tabIndex = -1;
          }
          card.querySelector('[data-learn-more]').href = data.url;
          const image = card.querySelector('.halloween-product__image img');
          if (image && data.image) {
            image.removeAttribute('srcset');
            image.src = data.image;
          }
        }, options);

        this.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-copy-code]');
          if (!button) return;
          const coupon = button.closest('.halloween-product__coupon');
          const status = coupon.querySelector('[data-copy-status]');
          button.disabled = true;
          try {
            await navigator.clipboard.writeText(button.dataset.copyCode);
            status.textContent = this.dataset.copySuccess;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(coupon.querySelector('[data-code-text]'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            status.textContent = this.dataset.copyFailed;
          } finally {
            button.disabled = false;
          }
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[role="tabpanel"]');
          const index = panel ? this.panels.indexOf(panel) : this.panels.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.activate(index);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      activate(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
      }
    });
  }

  if (!window.ikierHalloweenAccessoryBound) {
    window.ikierHalloweenAccessoryBound = true;
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-accessory-variant]');
      if (!select) return;
      const card = select.closest('[data-accessory-card]');
      const option = select.selectedOptions[0];
      if (!card || !option) return;
      const data = option.dataset;
      const price = card.querySelector('[data-current-price]');
      if (price) price.textContent = data.price || '';
      const compare = card.querySelector('[data-compare-price]');
      if (compare) {
        compare.textContent = data.compare || '';
        compare.hidden = !data.compare;
      }
      const saving = card.querySelector('[data-saving-label]');
      if (saving) {
        saving.textContent = data.saving || '';
        saving.hidden = !data.saving;
      }
      const button = card.querySelector('[data-accessory-submit]');
      if (button) {
        const available = data.available === 'true';
        button.disabled = !available;
        button.textContent = available ? card.dataset.addLabel : card.dataset.soldOutLabel;
      }
      const image = card.querySelector('.halloween-accessory__media img');
      if (image && data.image) {
        image.removeAttribute('srcset');
        image.src = data.image;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
